<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Loading page...',
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <Transition appear> </Transition>
  </Layout>
</template>

<style lang="scss" module></style>
